export default function initRecaptcha() {
  if (window.RECAPTCHA_ENABLED && window.RECAPTCHA_KEY) {
    if (!window.grecaptcha || !window.grecaptcha.enterprise) {
      const script = document.createElement('script');

      // Use the explicit 'enterprise.js' source rather than the standard v3 'api.js'
      script.src = `https://www.google.com/recaptcha/enterprise.js?render=${window.RECAPTCHA_KEY}`;
      script.async = true;
      script.defer = true;
      document.head.appendChild(script);
    }
    const form = document.querySelector('.recaptcha-form');
    if (form) {
      function executeRecaptcha(event) {
        const { recaptchaAction } = form.dataset;
        if (!recaptchaAction || !window.grecaptcha || !window.grecaptcha.enterprise) {
          return;
        }
        event.preventDefault();
        window.grecaptcha.enterprise.ready(async () => {
          const token = await window.grecaptcha.enterprise.execute(window.RECAPTCHA_KEY, { action: recaptchaAction });
          let input = form.querySelector('input[name="g-recaptcha-response"]');
          if (!input) {
            input = document.createElement('input');
            input.type = 'hidden';
            input.name = 'g-recaptcha-response';
            form.appendChild(input);
          }
          input.value = token;

          form.submit();
        });
      }

      form.addEventListener('submit', executeRecaptcha);
    }
  }
}
